import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";

import "./header.css";
import logo from "../../assets/img/logo.png";
import { useMediaQuery } from "react-responsive";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";

const Header = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const [toggleDrawerOpen, setToggleDrawerOpen] = useState(false);

  const clickedAboutMeScrollHandler = () => {
    props.scrollHandle("aboutme");
    setToggleDrawerOpen(false);
  };

  const clickedProjectsScrollHandler = () => {
    props.scrollHandle("projects");
    setToggleDrawerOpen(false);
  };

  const clickedTechStackScrollHandler = () => {
    props.scrollHandle("techstack");
    setToggleDrawerOpen(false);
  };

  const clickedCertificationsScrollHandler = () => {
    props.scrollHandle("certifications");
    setToggleDrawerOpen(false);
  };

  const clickedWorkXPScrollHandler = () => {
    props.scrollHandle("workxp");
    setToggleDrawerOpen(false);
  };

  const clickedContactMeScrollHandler = () => {
    props.scrollHandle("contactme");
    setToggleDrawerOpen(false);
  };

  const clickedGameDevHandler = () => {
    window.open("https://tkgamedev.netlify.app/");
  };

  const toggleDrawer = () => {
    setToggleDrawerOpen(!toggleDrawerOpen);
  };

  return (
    <div className="header">
      <Row
        style={{
          height: "100%",
          width: "100%",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        {isTabletOrMobile ? (
          <>
            <Button
              style={{
                color: "white",
                fontSize: "50px",
                marginLeft: "40px",
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-start"
              }}
              onClick={toggleDrawer}
            >
              <MenuIcon
                style={{
                  color: "white",
                  fontSize: "50px",
                }}
              />
            </Button>

            <Drawer anchor="left" open={toggleDrawerOpen}>
              <List
                style={{
                  backgroundColor: "#155bdd",
                  height: "100%",
                  width: "250px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#155bdd",
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button onClick={toggleDrawer}>
                    <CloseIcon style={{ color: "white" }} />
                  </Button>
                </div>

                <ListItem disablePadding>
                  <img id="header-logo" src={logo} width="100%" height="100%" />
                </ListItem>
                <br />
                <ListItem disablePadding>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <a id="link" onClick={clickedAboutMeScrollHandler}>
                      About me
                    </a>
                  </div>
                </ListItem>
                <br />
                <ListItem disablePadding>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <a id="link" onClick={clickedProjectsScrollHandler}>
                      Projects
                    </a>
                  </div>
                </ListItem>
                <br />
                <ListItem disablePadding>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <a id="link" onClick={clickedTechStackScrollHandler}>
                      Tech stack
                    </a>
                  </div>
                </ListItem>
                <br />
                <ListItem disablePadding>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <a id="link" onClick={clickedCertificationsScrollHandler}>
                      Certifications
                    </a>
                  </div>
                </ListItem>
                <br />
                <ListItem disablePadding>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <a id="link" onClick={clickedWorkXPScrollHandler}>
                      Work XP
                    </a>
                  </div>
                </ListItem>
                <br />
                <ListItem disablePadding>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <a id="link" onClick={clickedContactMeScrollHandler}>
                      Contact me
                    </a>
                  </div>
                </ListItem>
                <br />
                <ListItem disablePadding>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <a id="gamedevBtn" onClick={clickedGameDevHandler}>
                      GameDev
                    </a>
                  </div>
                </ListItem>
              </List>
            </Drawer>
          </>
        ) : (
          <>
            <Col>
              <div>
                <img id="header-logo" src={logo} width="90%" height="90%" />
              </div>
            </Col>
            <Col style={{ width: "20%" }}>
              <a id="link" onClick={clickedAboutMeScrollHandler}>
                About me
              </a>
            </Col>
            <Col>
              <a id="link" onClick={clickedProjectsScrollHandler}>
                Projects
              </a>
            </Col>
            <Col>
              <a id="link" onClick={clickedTechStackScrollHandler}>
                Tech stack
              </a>
            </Col>
            <Col>
              <a id="link" onClick={clickedCertificationsScrollHandler}>
                Certifications
              </a>
            </Col>
            <Col>
              <a id="link" onClick={clickedWorkXPScrollHandler}>
                Work XP
              </a>
            </Col>
            <Col>
              <a id="link" onClick={clickedContactMeScrollHandler}>
                Contact me
              </a>
            </Col>
            <Col>
              <a id="gamedevBtn" onClick={clickedGameDevHandler}>
                GameDev
              </a>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default Header;
